export default 'vertical'
